import { render, staticRenderFns } from "./DDocumentPreview.vue?vue&type=template&id=50cf24dc&"
import script from "./DDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./DDocumentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports